/**
 * MentionContentCard Component
 *
 * Displays the Reddit comment content for a mention
 * Shared component used by both MentionReviewDetailPage and BusinessMentionCard
 */
import React from 'react';
import { Card, Group, Text } from '@mantine/core';
import { IconBrandReddit } from '@tabler/icons-react';

export interface MentionContentCardProps {
  /**
   * Reddit comment text
   */
  content: string;

  /**
   * Whether to show the card border
   */
  withBorder?: boolean;

  /**
   * Card padding
   */
  padding?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  /**
   * Card shadow
   */
  shadow?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  /**
   * Whether to show the header icon and label
   */
  showHeader?: boolean;
}

/**
 * MentionContentCard - Reusable Reddit comment display
 */
export const MentionContentCard: React.FC<MentionContentCardProps> = ({
  content,
  withBorder = true,
  padding = 'md',
  shadow = 'sm',
  showHeader = true
}): React.ReactElement => {
  return (
    <>
      {showHeader && (
        <Group gap="xs" mb="xs">
          <IconBrandReddit size={20} />
          <Text size="md" fw={500}>
            Reddit Comment
          </Text>
        </Group>
      )}
      <Card withBorder={withBorder} padding={padding} shadow={shadow}>
        <Text
          size="sm"
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          }}
        >
          {content}
        </Text>
      </Card>
    </>
  );
};
